// Define validation schemas for each step of the form
export type ValidationError = {
  field: string;
  message: string;
};

export type ValidationResult = {
  isValid: boolean;
  errors: ValidationError[];
};

// Utility function to check if a value is empty
export const isEmpty = (value: any): boolean => {
  if (value === null || value === undefined) return true;
  if (typeof value === "string") return value.trim() === "";
  if (Array.isArray(value)) return value.length === 0;
  if (typeof value === "object") return Object.keys(value).length === 0;
  return false;
};

// Validate Step 1: Rate Your Experience
export const validateStep1 = (
  reportDetails: any,
  clientGroup: any,
  date: Date | null,
  inspectiontime: any,
  ratings: Record<string, number>, // <-- ratings passed from the call
  starRatings: any[] = [], // <-- metadata about rating fields
  staffMemberDesc: string,
  additionalNoteForShopper: string,
  textInputs: Record<string, string>,
  addOnQuestionAnswers: Record<string, string>,
  briefJson: any[],
  addOnQuestions: any[],
  uploadedFiles: Record<string, any[]>,
  checkIntime: any,
  npsData: any
): ValidationResult => {
  const errors: ValidationError[] = [];

  // Validate date
  if (!date) {
    errors.push({ field: "date", message: "Date of visit is required" });
  }
  if (!inspectiontime) {
    errors.push({ field: "inspectiontime", message: "visit Time is required" });
  }

  if ((npsData?.score === null ||
    npsData?.score === undefined ||
    npsData?.score === "" || npsData?.score < 0) && reportDetails?.allocationDetails?.clientEntityId?.isNPSenable) {
    errors.push({ field: "npsScore", message: "Please Select a net Promoter Score" });
  }
  const wordCount = (npsData?.feedback || "")
    .trim()
    .split(/\s+/)
    .filter(Boolean).length;
  // reportDetails?.allocationDetails?.clientEntityId?.isNPSenable
  if (
    reportDetails?.allocationDetails?.clientEntityId?.isNPSenable && reportDetails?.allocationDetails?.clientEntityId?.isNPSFeedbackRequired &&
    wordCount < 5
  ) {
    console.log("Nps Data", npsData)
    console.log("Word COunt", wordCount)
    errors.push({
      field: "npsComment",
      message: "Please enter at least 5 words in the comment."
    });
  }

  if (reportDetails?.allocationDetails?.clientEntityId?.isNPSenable && reportDetails?.allocationDetails?.clientEntityId?.isNPSFeedbackRequired && !npsData?.feedback) {
    errors.push({ field: "npsFeedback", message: "Please Describe a feedback" });
  }
  // Validate ratings
  if (!starRatings || starRatings.length === 0) {
    //errors.push({ field: "ratings", message: "At least one rating is required" });
  } else {
    let hasAtLeastOneRating = false;

    for (const ratingItem of starRatings) {
      const score = ratings?.[ratingItem.reportStarRatingId];

      if (score && score > 0) {
        hasAtLeastOneRating = true;
      } else {
        errors.push({
          field: `rating_${ratingItem.reportStarRatingId}`,
          message: `${ratingItem.starRatingDesc || "Rating"
            } must be greater than 0`,
        });
      }
    }

    if (!hasAtLeastOneRating) {
      errors.push({
        field: "ratings",
        message: "At least one rating is required",
      });
    }
  }

  // Validate staff member description
  if ((clientGroup === "MM" || clientGroup === "BLOOMS" || clientGroup == "EXTENDED" || clientGroup === "JBHIFI") && (reportDetails?.reportHeader?.clientEntityId != 128) && isEmpty(staffMemberDesc)) {
    errors.push({
      field: "staffMemberDesc",
      message: "Team member description is required",
    });
  }

  if (clientGroup === "BLOOMS" && isEmpty(additionalNoteForShopper)) {
    errors.push({
      field: "additionalNoteForShopper",
      message: "Additional Notes is required",
    });
  }

  // Validate text inputs for brief json
  briefJson?.forEach((item) => {
    const inputValue = textInputs[item.reportBriefJsonId];
    const wordCount =
      inputValue?.trim().split(/\s+/).filter(Boolean).length || 0;

    if (isEmpty(inputValue)) {
      errors.push({
        field: `textInput_${item.reportBriefJsonId}`,
        message: `${item.briefJsonTitle} is required`,
      });
    } else {
      if (item.minNoOfWords && wordCount < item.minNoOfWords) {
        errors.push({
          field: `textInput_${item.reportBriefJsonId}`,
          message: `${item.briefJsonTitle} must be at least ${item.minNoOfWords} words`,
        });
      }

      // if (item.maxNoOfWords && wordCount > item.maxNoOfWords) {
      //   errors.push({
      //     field: `textInput_${item.reportBriefJsonId}`,
      //     message: `${item.briefJsonTitle} must be at most ${item.maxNoOfWords} words`,
      //   });
      // }
    }
  });

  addOnQuestions?.forEach((item) => {
    const inputValue = addOnQuestionAnswers[item.reportAddOnQuestionId];

    if (isEmpty(inputValue)) {
      errors.push({
        field: `addOnQuestionField_${item.reportAddOnQuestionId}`,
        message: `${item.addOnQuestionText} is required`,
      });
    }
  });

  if (localStorage.getItem("IsCheckInSuccessfull") != "true" && !reportDetails?.reportHeader?.checkInDateTime && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor') {
    if (!uploadedFiles.checkInFile || uploadedFiles.checkInFile.length === 0) {
      console.log("Error that checkIn time is reqired from step-1")
      errors.push({
        field: "checkInFile",
        message: "Check-in photo is required",
      });
    }
    else if (uploadedFiles.checkInFile.length > 1) {
      errors.push({
        field: "checkInFile",
        message: "Only 1 Image can be upload For Check In File",
      });
    }

    if (!checkIntime || isNaN(new Date(checkIntime).getTime())) {
      errors.push({ field: "checkIntime", message: "Check-In Date is required" });
    }

  }
  return {
    isValid: errors.length === 0,
    errors,
  };
};


// Validate Step 2: Questions Bank
// export const validateStep2 = (
//   answers: Record<string, any>,
//   questionsData: any,
//   currentCategoryIndex: number,
// ): ValidationResult => {
//   const errors: ValidationError[] = []

//   if (!questionsData || !questionsData.questions) {
//     return { isValid: false, errors: [{ field: "general", message: "Questions data is missing" }] }
//   }

//   // Only validate questions from the current category
//   const currentCategory = questionsData.questions[currentCategoryIndex]
//   if (!currentCategory || !currentCategory.questions) {
//     return { isValid: true, errors: [] } // No questions to validate
//   }

//   // Get unique questions from the current category
//   //const uniqueQuestions = Array.from(new Map(currentCategory.questions.map((q: any) => [q.questionId, q])).values())
//   const uniqueQuestions = currentCategory.questions;

//   // Check if all required questions in the current category are answered
//   uniqueQuestions.forEach((question: any) => {
//     const answer = answers[question.questionId]
//     const isRequired = question.isRequired !== 0 // Assuming 0 means not required

//     if (isRequired) {
//       if (!answer) {
//         errors.push({
//           field: `question_${question.questionId}`,
//           message: `Question "${question.questions.replace(/<[^>]*>/g, "")}" must be answered`,
//         })
//       } else if (isEmpty(answer.value)) {
//         errors.push({
//           field: `question_${question.questionId}`,
//           message: `Question "${question.questions.replace(/<[^>]*>/g, "")}" must be answered`,
//         })
//       }
//     }
//   })

//   return {
//     isValid: errors.length === 0,
//     errors,
//   }
// }

export const validateStep2 = (
  answers: Record<string, any>,
  questionsData: any,
  currentCategoryIndex: number
): ValidationResult => {
  const errors: ValidationError[] = [];

  if (!questionsData || !questionsData.questions) {
    return {
      isValid: false,
      errors: [{ field: "general", message: "Questions data is missing" }],
    };
  }

  // Only validate questions from the current category
  const currentCategory = questionsData.questions[currentCategoryIndex];
  if (!currentCategory || !currentCategory.questions) {
    return { isValid: true, errors: [] }; // No questions to validate
  }

  // Get unique questions from the current category
  const uniqueQuestions = Array.from(
    new Map(
      currentCategory.questions.map((q: any) => [q.questionId, q])
    ).values()
  );

  //const uniqueQuestions = currentCategory.
  // questions

  // Check if all required questions in the current category are answered
  uniqueQuestions.forEach((question: any) => {
    const answer = answers[question.questionId];
    const isRequired = question.isRequired !== 0; // Assuming 0 means not required

    if (isRequired) {
      if (!answer) {
        errors.push({
          field: `question_${question.questionId}`,
          message: `must be answered`,
        });
      } else if (isEmpty(answer.value)) {
        errors.push({
          field: `question_${question.questionId}`,
          message: `must be answered`,
        });
      }

    }

    // Validate image requirements if an answer is provided
    if (answer && answer.value) {
      try {
        // Get the selected option to check if it requires images
        const options = JSON.parse(question.qOptionJson || "[]");
        const selectedOption = options.find(
          (opt: any) => opt.value === answer.value
        );

        if (selectedOption && selectedOption.optionImage > 0) {
          // Check if the required number of images are uploaded
          const uploadedImages = answer.photoUrl
            ? answer.photoUrl.split(",").filter(Boolean).length
            : 0;

          if (uploadedImages < selectedOption.optionImage) {
            errors.push({
              field: `question_${question.questionId}_images`,
              message: `This answer requires minimum ${selectedOption.optionImage
                } image${selectedOption.optionImage > 1 ? "s" : ""
                }. `,
            });
          }
        }

        // ✅ Validate minChar for comment
        if (selectedOption?.minChar === 0) {
          return;
        }
        if ((selectedOption?.optionComment)?.toLowerCase() == "yes" && (answer.comment || "").trim().split(/\s+/).length < selectedOption?.minChar) {
          alert(`Answer ${answer.comment}`)
          alert(`Option Id  ${question.questionId}`)
          errors.push({
            field: `question_${question.questionId}_comment`,
            message: `Minimum ${selectedOption?.minChar} word required in comment.`,
          });
        }
      } catch (error) {
        console.error("Error parsing options JSON:", error);
      }
    }
  });

  return {
    isValid: errors.length === 0,
    errors,
  };
};
export const AldivalidateStep2 = (
  answers: Record<string, any>,
  questionsData: any
): ValidationResult => {
  const errors: ValidationError[] = [];

  if (!questionsData || !questionsData.questions) {
    return {
      isValid: false,
      errors: [{ field: "general", message: "Questions data is missing" }],
    };
  }

  const orderedQuestions = Array.from(
    new Map(
      questionsData.questions
        .flatMap((category: any) =>
          category.questions.map((q: any) => ({
            ...q,
            categoryName: category.categoryName,
          }))
        )
        .map((q: any) => [q.questionId, q]) // dedupe
    ).values()
  )
    .filter((q: any) => q.displayOrder !== undefined)
    .sort((a: any, b: any) => a.displayOrder - b.displayOrder);

  orderedQuestions.forEach((question: any) => {
    const answer = answers[question.questionId];
    const isRequired = question.isRequired !== 0; // Assuming 0 means not required

    if (isRequired) {
      if (!answer || isEmpty(answer.value) || (answer.score == null && question.maxScore !== 0)) {
        errors.push({
          field: `question_${question.questionId}`,
          message: 'must be answered'
        });
      }
      if (question.qType === "T") {
        if (question.minChar > 0 &&
          (answer.value?.trim().split(/\s+/).length < question.minChar)) {
          errors.push({
            field: `question_${question.questionId}`,
            message: `minimum  ${question.minChar} words required`,
          });
        }
      }
    }

    // Validate image requirements if answer exists
    if (answer && answer.value) {
      try {
        const options = JSON.parse(question.qOptionJson || "[]");
        const selectedOption = options.find(
          (opt: any) => opt.value === answer.value
        );

        if (selectedOption && selectedOption.optionImage > 0) {
          const uploadedImages = answer.photoUrl
            ? answer.photoUrl.split(",").filter(Boolean).length
            : 0;

          if (uploadedImages < selectedOption.optionImage) {
            errors.push({
              field: `question_${question.questionId}_images`,
              message: `This answer requires minimum ${selectedOption.optionImage
                } image${selectedOption.optionImage > 1 ? "s" : ""}.`,
            });
          }
        }

        if (selectedOption?.minChar && (selectedOption?.optionComment)?.toLowerCase() == "yes" && (answer.comment || "").trim().split(/\s+/).filter(Boolean).length < selectedOption.minChar) {
          errors.push({
            field: `question_${question.questionId}_comment`,
            message: `Minimum ${selectedOption.minChar} words required in comment.`,
          });
        }
      } catch (error) {
        console.error("Error parsing options JSON:", error);
      }
    }
    if (question.isPhotoRequire > 0) {
      try {
        const uploadedImages = answer.photoUrl
          ? answer.photoUrl.split(",").filter(Boolean).length
          : 0;

        if (uploadedImages < question.minPhoto) {
          errors.push({
            field: `question_${question.questionId}_images`,
            message: `This question requires minimum ${question.minPhoto
              } image${question.minPhoto > 1 ? "s" : ""}.`,
          });
        }
      } catch (error) {
        console.error("Error parsing options JSON:", error);
      }
    }
    // if (answer.score == null && question.maxScore !== 0 ) {
    //   errors.push({
    //     field: `question_${question.questionId}_score`,
    //     message: `question score is required.`,
    //   });
    // }
    if (answer.score > answer.maxScore) {
      errors.push({
        field: `question_${question.questionId}_score`,
        message: `question score should be less than max Score.`,
      });
    }

  });

  const uniqueErrors = Array.from(
    new Map(
      errors.map(err => {
        const questionId = err.field?.match(/\d+/)?.[0] || "";
        const key = `${questionId}_${err.message}`;
        return [key, err];
      })
    ).values()
  );

  // return {
  //   isValid: errors.length === 0,
  //   errors,
  // };
  return {
    isValid: uniqueErrors.length === 0,
    errors: uniqueErrors,
  };
};


// Validate Step 3: Other Details
export const validateStep3 = (
  invoice: { food: number; bar: number; gaming: number; bottleshop: number; total: string },
  uploadedFiles?: Record<string, any[]>,
  reportDetails?: any,
  checkOuttime?: any,
  checkIntime?: any,
): ValidationResult => {
  const errors: ValidationError[] = [];
  // Validate invoice total
  if (parseInt(invoice.total) < 0 && reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0 && (
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bottleshop") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("food") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fb") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("fbg") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("gaming") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("retail") ||
    reportDetails.entityTypeDetails.entityTypeName?.toLowerCase().includes("bar"))) {
    errors.push({
      field: "invoice_total",
      message: `Total invoice amount must be greater than 0.`,
    });
  }

  // Validate required files
  if (reportDetails?.reportHeader?.allocationClientGroup !== "ALDI") {
    if (uploadedFiles.taskPhotos?.length < reportDetails?.minNoOfImages) {
      errors.push({
        field: "taskPhotos",
        message: `minimum ${reportDetails?.minNoOfImages} task photo is required`,
      });
    }
  }
  if (reportDetails?.reportHeader?.allocationClientGroup !== "TRANSPORT") {
    if (
      (!uploadedFiles.invoiceReceipt ||
        uploadedFiles.invoiceReceipt.length === 0) &&
      reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0
    ) {
      errors.push({
        field: "invoiceReceipt",
        message: "At least one invoice/receipt photo is required",
      });
    }
  }


  if (localStorage.getItem("IsCheckOutSuccessfull") !== 'true' && !reportDetails?.reportHeader?.checkOutDateTime && localStorage.getItem('liveuserRole') !== 'admin' && localStorage.getItem('liveuserRole') !== 'superadmin' && localStorage.getItem("liveuserRole") !== 'editor') {

    if (!uploadedFiles.checkOutFile || uploadedFiles.checkOutFile.length === 0) {
      errors.push({
        field: "checkOutFile",
        message: "Check-out photo is required",
      });

    } else if (uploadedFiles.checkOutFile.length > 1) {
      errors.push({
        field: "checkOutFile",
        message: "Only 1 Image can be upload For Check Out File",
      });
    }
    if (!checkOuttime || isNaN(new Date(checkOuttime).getTime())) {
      errors.push({ field: "checkOuttime", message: "Check-Out Date is required" });
    }

  }
  if (
    checkIntime &&
    checkOuttime &&
    !isNaN(new Date(checkIntime).getTime()) &&
    !isNaN(new Date(checkOuttime).getTime()) &&
    new Date(checkOuttime).getTime() <= new Date(checkIntime).getTime()
  ) {
    errors.push({
      field: "checkOuttime",
      message: "Check-Out Date must be greater than Check-In Date",
    });
  }

  // if (reportDetails?.reportHeader?.allocationClientGroup === "ALDI" && reportDetails?.clientEntityName === 'Audit') {
  //   if (!uploadedFiles.shopperBagImages || uploadedFiles.shopperBagImages.length === 0) {
  //     errors.push({
  //       field: "shopperBagImages",
  //       message: "Bag photo is required",
  //     });
  //   } else if (uploadedFiles.shopperBagImages.length > 1) {
  //     errors.push({
  //       field: "shopperBagImages",
  //       message: "Only 1 Image can be upload For bag image",
  //     });
  //   }
  // }
  return {
    isValid: errors.length === 0,
    errors,
  };
};
// export const validateStep3 = (
//   invoice: { food: number; bar: number; gaming: number; bottleshop: number; total: number },
//   uploadedFiles: Record<string, any[]>,
//   reportDetails
// ): ValidationResult => {
//   const errors: ValidationError[] = [];

//   // Helper to check if file array has at least one valid file
//   const isFileArrayValid = (files?: any[]) => {
//     if (!files || !Array.isArray(files) || files.length === 0) return false;
//     return files.some(file => {
//       if (typeof file === "string") {
//         return file.trim() !== "";
//       }
//       return file instanceof File; // or any other valid file object check
//     });
//   };

//   // Validate invoice total
//   if (
//     invoice.total <= 0 &&
//     reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0
//   ) {
//     errors.push({
//       field: "invoice_total",
//       message: "Total invoice amount must be greater than 0",
//     });
//   }

//   // Task photos
//   if (!isFileArrayValid(uploadedFiles.taskPhotos)) {
//     errors.push({
//       field: "taskPhotos",
//       message: "At least one task photo is required",
//     });
//   }

//   // Invoice/receipt
//   if (
//     !isFileArrayValid(uploadedFiles.invoiceReceipt) &&
//     reportDetails?.reportOtherDetails?.isNeedToHideInvoicePanel === 0
//   ) {
//     errors.push({
//       field: "invoiceReceipt",
//       message: "At least one invoice/receipt photo is required",
//     });
//   }

//   // Check-in file
//   if (!isFileArrayValid(uploadedFiles.checkInFile)) {
//     errors.push({
//       field: "checkInFile",
//       message: "Check-in photo is required",
//     });
//   } else if (uploadedFiles.checkInFile.length > 0) {
//     errors.push({
//       field: "checkInFile",
//       message: "Only 1 image can be uploaded for Check-In File",
//     });
//   }

//   // Check-out file
//   if (!isFileArrayValid(uploadedFiles.checkOutFile)) {
//     errors.push({
//       field: "checkOutFile",
//       message: "Check-out photo is required",
//     });
//   } else if (uploadedFiles.checkOutFile.length > 1) {
//     errors.push({
//       field: "checkOutFile",
//       message: "Only 1 image can be uploaded for Check-Out File",
//     });
//   }

//   // ALDI specific validation
//   if (reportDetails?.reportHeader?.allocationClientGroup === "ALDI") {
//     if (!isFileArrayValid(uploadedFiles.shopperBagImages)) {
//       errors.push({
//         field: "shopperBagImages",
//         message: "Bag photo is required",
//       });
//     } else if (uploadedFiles.shopperBagImages.length > 1) {
//       errors.push({
//         field: "shopperBagImages",
//         message: "Only 1 image can be uploaded for Bag Image",
//       });
//     }
//   }

//   return {
//     isValid: errors.length === 0,
//     errors,
//   };
// };
